import React from 'react';
export var NightIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
    React.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
    React.createElement("path", { d: "M8.001 8a6.496 6.496 0 014.998-6.318A6.955 6.955 0 0010.001 1a7 7 0 100 14 6.955 6.955 0 002.998-.682A6.497 6.497 0 018.001 8z", fill: "#4997c7" }))); };
//# sourceMappingURL=NightIcon.js.map